var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConvertCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44 28.5C44.8284 28.5 45.5 29.1716 45.5 30C45.5 38.5684 38.5684 45.5 30 45.5C29.4596 45.5 28.961 45.2093 28.6947 44.7391C28.4284 44.2688 28.4357 43.6917 28.7138 43.2283L30.8137 39.7283C31.24 39.0179 32.1613 38.7875 32.8717 39.2138C33.5821 39.64 33.8124 40.5614 33.3862 41.2717L32.8436 42.1761C38.3818 40.8913 42.5 35.9332 42.5 30C42.5 29.1716 43.1716 28.5 44 28.5Z",
    fill: "url(#paint0_linear_150_32983)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1564 5.82387C9.61821 7.10873 5.5 12.0668 5.5 18C5.5 18.8284 4.82843 19.5 4 19.5C3.17157 19.5 2.5 18.8284 2.5 18C2.5 9.43157 9.43157 2.5 18 2.5C18.5404 2.5 19.039 2.79069 19.3053 3.26095C19.5716 3.73121 19.5643 4.30834 19.2862 4.77174L17.1863 8.27174C16.76 8.98211 15.8387 9.21246 15.1283 8.78624C14.4179 8.36002 14.1876 7.43864 14.6138 6.72826L15.1564 5.82387Z",
    fill: "url(#paint1_linear_150_32983)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24 31.4V32.62H4V31.4C4 27.88 4.88 27 8.44 27H19.56C23.12 27 24 27.88 24 31.4Z",
    fill: "url(#paint2_linear_150_32983)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 32.62V35.62V39.6C4 43.12 4.88 44 8.44 44H19.56C23.12 44 24 43.12 24 39.6V35.62V32.62H4Z",
    fill: "url(#paint3_linear_150_32983)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M44 8.4V9.62H24V8.4C24 4.88 24.88 4 28.44 4H39.56C43.12 4 44 4.88 44 8.4Z",
    fill: "url(#paint4_linear_150_32983)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 9.62V12.62V16.6C24 20.12 24.88 21 28.44 21H39.56C43.12 21 44 20.12 44 16.6V12.62V9.62H24Z",
    fill: "url(#paint5_linear_150_32983)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_150_32983",
    x1: 28.4906,
    y1: 37.0001,
    x2: 45.5094,
    y2: 37.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#E5774D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#AE02A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1801A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_150_32983",
    x1: 2.49059,
    y1: 11.0001,
    x2: 19.5094,
    y2: 11.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#E5774D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#AE02A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1801A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_150_32983",
    x1: 3.98893,
    y1: 29.81,
    x2: 24.0111,
    y2: 29.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#E5774D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#AE02A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1801A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_150_32983",
    x1: -8.9675,
    y1: 46.0591,
    x2: 11.6827,
    y2: 13.0399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E5774D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#AE02A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1801A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_150_32983",
    x1: 23.9889,
    y1: 6.81003,
    x2: 44.0111,
    y2: 6.81003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#E5774D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#AE02A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1801A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_150_32983",
    x1: 11.0325,
    y1: 23.0591,
    x2: 31.6827,
    y2: -9.96014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E5774D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#AE02A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1801A1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvertCard);
export default __webpack_public_path__ + "static/media/convert-card.8127833b9c4d06cb74c71dc40c82a824.svg";
export { ForwardRef as ReactComponent };